import React, { FC } from 'react'
import EditRepContainer from 'containers/Rep/EditRep'

const EditRepPage: FC = () => <EditRepContainer />

export default EditRepPage
